import { render } from "./EditSocietePage.vue?vue&type=template&id=aecd908a&ts=true"
import script from "./EditSocietePage.vue?vue&type=script&lang=ts"
export * from "./EditSocietePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__